export const AUTH0_SCOPES = 'openId read:all user_metadata';
export const PROJECT = 'pkdf-pkd2';
export const MAX_PROFILE_IMAGE_SIZE_IN_MB = 5;
export const MAX_PROFILE_IMAGE_WIDTH_IN_PX = 300;
